export var getRenderResolution = function () {
    var innerWidth = window.innerWidth || 0;
    var innerHeight = window.innerHeight || 0;
    if (innerWidth === 0 || innerHeight === 0) {
        innerWidth = screen.width || 1280;
        innerHeight = screen.height || 720;
        console.warn("[RenderRes] window dimensions unavailable, using screen fallback");
    }
    if (innerWidth < 640 || innerHeight < 360) {
        console.error("[RenderRes] Invalid dimensions (" + innerWidth + "\u00D7" + innerHeight + "), using fallback");
        innerWidth = 1280;
        innerHeight = 720;
    }
    var devicePixelRatio = window.devicePixelRatio || 1;
    return {
        width: Math.round(innerWidth * devicePixelRatio),
        height: Math.round(innerHeight * devicePixelRatio),
        innerWidth: innerWidth,
        innerHeight: innerHeight,
        devicePixelRatio: devicePixelRatio,
    };
};



//////////////////
// WEBPACK FOOTER
// ./src/utils/RenderResolution.ts
// module id = 202
// module chunks = 1